import { ENQUIRIES_FAIL, ENQUIRIES_REQUEST, ENQUIRIES_SUCCESS } from './enquiryTypes'
export const enquiryReducer = (state = {}, action ) => {

    switch (action.type) {

        case ENQUIRIES_REQUEST:
            return {...state, loading: true }

        case ENQUIRIES_SUCCESS:
            return { ...state,loading: false, enquiries: action.payload }

        case ENQUIRIES_FAIL:
            return {...state, loading: false, error: action.payload }

        default:
            return state;
    }
}